import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Input,
  Badge,
  Label,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  FormGroup,
} from "reactstrap"
import {
  AlertCircle,
  Activity,
  Video,
  Pill,
  RefreshCw,
  Heart,
  Mail,
  User,
  Trash2,
  ChevronDown,
  ChevronUp,
  ThermometerSun,
  UserPlus,
  Camera,
  Settings,
  ArrowLeft,
  Smartphone, Bluetooth,
  AlertTriangle,
} from 'lucide-react';

import ClipLoader from "react-spinners/ClipLoader";
import withRouter from "components/Common/withRouter"
import axios from "axios"
import LoadingSpinner from "components/Common/loadingSpinner/LoadingSpinner"
import OverwriteManagerModal from "./Modals/OverwriteManagerModal"
import * as AxisUtility from "helpers/camera_utility"
import * as HanwhaUtility from "helpers/hanwha_camera_utility"
import AxisCameraDeviceCard from "./Modals/NewMeasurementModalPages/AxisCameraDeviceCard"
import HanwhaCameraDeviceCard from "./Modals/NewMeasurementModalPages/HanwhaCameraDeviceCard"
import { getLocalLinkIP } from "helpers/ip_extract"
import DeviceStatusDashboard from "./Modals/NewMeasurementModalPages/DeviceStatusDashboard"
import DashboardStatistics from './PatientStatistics/DashboardStatistics';
import PatientsList from './PatientsList';

//Modal imports
import NewMeasurementModal from "./Modals/NewMeasurementModal"
import AddPatientModal from './Modals/AddPatientModal';
import UpdatePatientModal from './Modals/UpdatePatientModal';
import StudyCompletionModal from './Modals/StudyCompletionModal';
import SubjectDetailsModal from './Modals/SubjectDetailsModal';
import RoomTemperatureModal from './Modals/RoomTemperatureModal';
import ManualBloodPressureModal from './Modals/ManualBloodPressureModal';
import ImportantMedicationModal from './Modals/ImportantMedicationModal';
import TeleconferenceModal from './Modals/TeleconferenceModal';
import { get, set } from "lodash";
import WarningAlert from "./WarningAlert";
import PPGDataCollection  from "./PPGDataCollection";
import BreathingPPGDataCollection  from "./BreathingPPGDataCollection";


let BASE_URL = process.env.REACT_APP_BASE_URL
let SOCKET_URL = process.env.REACT_APP_SOCKET_URL
let AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL
const ENV_RESOURCE = process.env.REACT_APP_ENV_RESOURCE

const Dashboard = () => {
  document.title = "Data Collector"

  //Loading Variables
  const [dashboardLoading, setDashboardLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [patientsLoading, setPatientsLoading] = useState(false)


  //Data Variables
  const [dashboardData, setDashboardData] = useState([])
  const [userChanges, setUserChanges] = useState({})
  const [selectedSubject, setSelectedSubject] = useState(null)
  const [subjects, setSubjects] = useState([])
  const [messages, setMessages] = useState({})
  const [lastMessages, setLastMessages] = useState({})
  const [measurementData, setMeasurementData] = useState({})
  const [statusData, setStatusData] = useState({})
  const [noSubjects, setNoSubjects] = useState(true)
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState([]);
  const [requestResult, setRequestResult] = useState(null);
  const [annotatingSession, setAnnotatingSession] = useState(null);
  const [annotationMessages, setAnnotationMessages] = useState({});



  //Modal Variables
  const [modalOpen, setModalOpen] = useState(false)
  const [overwriteManagerModalOpen, setOverwriteManagerModalOpen] =
    useState(false)
  const [addModalOpen, setAddModalOpen] = useState(false)
  const [updateModalOpen, setUpdateModalOpen] = useState(false)
  const [studyCompletionModalOpen, setStudyCompletionModalOpen] =
    useState(false)
  const [bloodSugarModalOpen, setBloodSugarModalOpen] = useState(false)
  const [deleteDevicesModalOpen, setDeleteDevicesModalOpen] = useState(false)
  const [teleconferenceModalOpen, setTeleconferenceModalOpen] = useState(false);
  const [bloodPressureModalOpen, setBloodPressureModalOpen] = useState(false);
  const [bloodModalLoading, setBloodModalLoading] = useState(false);
  const [lastAte, setLastAte] = useState("");
  const [glucoseLevel, setGlucoseLevel] = useState("");
  const [medicationModalOpen, setMedicationModalOpen] = useState(false);
  const [roomTempModalOpen, setRoomTempModalOpen] = useState(false);

  //State Variables
  const [currentPage, setCurrentPage] = useState(1) // Page 1 is the initial page
  const [connectionId, setConnectionId] = useState(null)
  const [roomTemperature, setRoomTemperature] = useState(null);
  const [roomTemperatureUnit, setRoomTemperatureUnit] = useState(null);
  const [closeYourself, setCloseYourself] = useState(false)
  const [diskFetchInterval, setDiskFetchInterval] = useState(5000)
  const [isStatsOpen, setIsStatsOpen] = useState(false);

  // Ref Variables
  const connectionIdRef = useRef(null)
  const socketRef = useRef(null)
  const reconnectTimeoutRef = useRef(null)
  const modalOpenRef = useRef(modalOpen)
  const addModalOpenRef = useRef(addModalOpen)
  const updateModalOpenRef = useRef(updateModalOpen)
  const studyCompletionModalOpenRef = useRef(studyCompletionModalOpen)
  const bloodSugarModalOpenRef = useRef(bloodSugarModalOpen)
  const currentPageRef = useRef(currentPage)
  const [deviceStatuses, setDeviceStatuses] = useState({});
  // Camera related states
  const [axisCameras, setAxisCameras] = useState([
    { hostname: "carex-axis.mshome.net", type: "axis", connected: false, status: "", retryIntervalId: null, networkShare: null, disk: null, recording: false, recordingProfile: "" },
  ]);

  const [hanwhaCameras, setHanwhaCameras] = useState([
    { hostname: "carex-hanwha.mshome.net", type: "hanwha", connected: false, status: "", networkShare: null, disk: null, recording: false, id: 'e5bf9fa9-4788-3eef-4216-bc9abf0ca979' },
  ])
  const [deviceIP, setDeviceIP] = useState("")
  const [connectedCameraDevices, setConnectedCameraDevices] = useState([])
  const [deviceCheck, setDeviceCheck] = useState(false)
  const initialFetchCompleted = useRef(new Set());
  const fetchedIP = useRef(false);

  const [currentView, setCurrentView] = useState('dashboard');

  //Use Effect Functions
  useEffect(() => {
    console.log("selectedSubject", selectedSubject)
  }, [selectedSubject])


  useEffect(() => {
    // Clean up on component unmount
    return () => {
      // Clear
      axisCameras.forEach(camera => {
        if (camera.retryIntervalId) {
          clearTimeout(camera.retryIntervalId);
        }
      });
    }
  }, []);

  useEffect(() => {
    const fetchLocalLinkIP = async () => {
      if (!fetchedIP.current) {  // Only fetch if it hasn't been fetched yet
        try {
          const ip = await getLocalLinkIP()
          console.log("Ip address set", ip)
          setDeviceIP(ip);
          fetchedIP.current = true;
        } catch (error) {
          console.error(error)
          setWebRTCIPRetrivalFailed(true)
        }
      }
    }

    const anyCameraConnected = [...axisCameras, ...hanwhaCameras].some(cam => cam.connected);
    if (anyCameraConnected) {
      fetchLocalLinkIP();
    }

  }, [axisCameras, hanwhaCameras]);

  useEffect(() => {
    const fetchAvailableDisk = async (camera) => {
      const key = camera.hostname + '_disk';
      if (initialFetchCompleted.current.has(key)) return;  // Prevent repeated fetching when the dependencies change.
      console.log("Fetching available disk for", camera.hostname);

      try {
        if (camera.type === "axis") {
          const disk = await AxisUtility.getNetworkShareDisk(camera.hostname);
          if (disk) {
            setAxisCameras(prevCameras => prevCameras.map(cam =>
              cam.hostname === camera.hostname ? { ...cam, disk: disk } : cam));
            initialFetchCompleted.current.add(key);  // Mark as fetched
          }
        } else if (camera.type === "hanwha") {
          const disk = await HanwhaUtility.getNetworkShareDisk(camera.hostname);
          console.log("hanwha disk", disk);
          if (disk) {
            console.log("Axis camera disk", axisCameras[0]?.disk);
            setHanwhaCameras(prevCameras => prevCameras.map(cam =>
              cam.hostname === camera.hostname ? { ...cam, disk: { totalsize: axisCameras[0]?.disk?.totalsize || 50, freesize: axisCameras[0]?.disk?.freesize || 50, status: axisCameras[0]?.disk?.status || '' }, networkShare: disk?.NASConfig?.DefaultFolder } : cam));
            initialFetchCompleted.current.add(key);
          }
        }
      } catch (error) {
        console.error("Error fetching available disk", error);
      }
    };

    const fetchNetworkShare = async (camera) => {
      const key = camera.hostname + '_networkShare';
      if (initialFetchCompleted.current.has(key)) return;  // Prevent repeated fetching

      try {
        const share = await AxisUtility.getNetworkShare(camera.hostname);
        if (share) {
          console.log("Share already exists.", share);
          setAxisCameras(prevCameras => prevCameras.map(cam =>
            cam.hostname === camera.hostname ? { ...cam, networkShare: share } : cam));
          initialFetchCompleted.current.add(key);  // Mark as fetched
        }
      } catch (error) {
        console.error("Error fetching network share", error);
      }
    };

    const runInOrder = async () => {
      for (let camera of axisCameras) {
        if (camera.connected && deviceIP) {
          await fetchNetworkShare(camera);
          await fetchAvailableDisk(camera);
          // Additional operations can be handled here
        }
      }

      for (let camera of hanwhaCameras) {
        if (camera.connected && deviceIP) {
          await fetchAvailableDisk(camera);
        }
      }
    };

    runInOrder();

  }, [deviceIP, axisCameras, hanwhaCameras]);

  useEffect(() => {
    // Function to update camera devices
    const updateCameraDevices = (cameras) => {
      const connectedDevices = cameras.filter(camera => {
        return camera.disk && camera.disk.totalsize !== 0;
        //TODO: Add additional checks for Hanwha cameras
      }).map(camera => ({
        details: {
          hostname: camera.hostname,
          deviceIP: camera.deviceIP,  // Ensure device IP is managed per camera
          id: camera?.id
        },
        disk: camera.disk,
        networkShare: camera?.networkShare,
        type: camera.type
      }));

      console.log("Connected camera devices", connectedDevices);
      setConnectedCameraDevices(connectedDevices);
    };

    // Combine the camera arrays and update devices
    const allCameras = [...axisCameras, ...hanwhaCameras];
    console.log("All cameras", allCameras);
    updateCameraDevices(allCameras);

  }, [axisCameras, hanwhaCameras]);

  useEffect(() => {
    //close existing socket connection
    closeWebSocketConnection(socketRef);
    setLoading(true)
    connectWebSocket()
    return () => {
      clearTimeout(reconnectTimeoutRef.current)
      socketRef.current?.close()
    }
  }, [])

  useEffect(() => {
    setNoSubjects(
      subjects.length === 0 ||
      subjects === null ||
      selectedSubject === undefined ||
      selectedSubject === ""
    )
  }, [subjects, selectedSubject])

  // Modal Ref Use Effects

  useEffect(() => {
    modalOpenRef.current = modalOpen
  }, [modalOpen])

  useEffect(() => {
    if (addModalOpenRef.current !== addModalOpen) {
      addModalOpenRef.current = addModalOpen
      if (!addModalOpen.current) {
        checkDashboardStatus()
      }
    }

  }, [addModalOpen])

  useEffect(() => {
    if (updateModalOpenRef.current !== updateModalOpen) {
      updateModalOpenRef.current = updateModalOpen
      if (!updateModalOpenRef.current) {
        checkDashboardStatus()
      }
    }
  }, [updateModalOpen])

  useEffect(() => {
    if (studyCompletionModalOpenRef.current !== studyCompletionModalOpen) {
      studyCompletionModalOpenRef.current = studyCompletionModalOpen
      if (!studyCompletionModalOpenRef.current) {
        checkDashboardStatus()
      }
    }
  }, [studyCompletionModalOpen])

  useEffect(() => {
    if (bloodSugarModalOpenRef.current !== bloodSugarModalOpen) {
      bloodSugarModalOpenRef.current = bloodSugarModalOpen
      if (!bloodSugarModalOpenRef.current) {
        checkDashboardStatus()
      }
    }
  }, [bloodSugarModalOpen])

  useEffect(() => {
    if (bloodSugarModalOpen) {
      // Reset state when the modal is opened
      setLastAte("");
      setGlucoseLevel("");
      setErrors([]);
      setRequestResult(null);
    }
  }, [bloodSugarModalOpen]);

  useEffect(() => {
    currentPageRef.current = currentPage
  }, [currentPage])

  useEffect(() => {
    const cameraDeviceConnected = connectedCameraDevices.length > 0;
    const phoneDevicesConnected = dashboardData.length > 0;

    const phoneDevicesCheck = (phoneDevicesConnected &&
      dashboardData.some(
        device =>
          device.data === null ||
          (device?.deviceName?.toLowerCase()?.includes("iphone") &&
            device?.data?.deviceInfo?.remainingSpace > 2048) ||
          device?.data?.deviceInfo?.remainingSpace > 5120
      ));

    const cameraDevicesCheck = connectedCameraDevices.every(camera =>
      camera.disk.freesize > camera.disk.totalsize * 0.05);

    setDeviceCheck(
      (cameraDeviceConnected && cameraDevicesCheck) ||
      (phoneDevicesConnected && phoneDevicesCheck)
    );
  }, [dashboardData, connectedCameraDevices]);


  //Toggle Functions
  const toggleRoomTempModal = () => setRoomTempModalOpen(!roomTempModalOpen);
  const toggleAddModal = () => setAddModalOpen(!addModalOpen);

  const toggleDeleteDevicesModal = () => {
    setDeleteDevicesModalOpen(!deleteDevicesModalOpen)
  }

  const handleOverwriteConfirm = () => {
    if (socketRef.current) {
      socketRef.current.close()
    }
    setOverwriteManagerModalOpen(false)
    connectWebSocket()
  }
  const handleViewDetails = () => {
    toggleDetailsModal();
  };
  const handleCompleteStudy = () => {
    toggleStudyCompletionModal();
  };

  const toggleModal = async () => {
    setModalOpen(!modalOpen)
    if (!modalOpen) {
      setMessages({})
      setLastMessages({})
      setAnnotationMessages({})
      const selected = subjects.find(subject => subject.selected)
      setSelectedSubject(selected)
    } else {
      setDashboardLoading(true)
      const updatedSubjects = await getDashboard();
      // Find the selected subject from the returned subjects
      const selected = updatedSubjects.find(subject => subject.selected);
      console.log("Selected Subject:", selected);
      if (selected) {
        setSelectedSubject(selected);
      }
      setMessages({})
      setLastMessages({})
      setAnnotationMessages({})
    }
  }

  const handleImportantMedicationModal = () => {
    setMedicationModalOpen(true);
  };
  const handleBloodPressure = () => {
    setBloodPressureModalOpen(true);
  };

  const handleBloodSugar = () => {
    setBloodSugarModalOpen(!bloodSugarModalOpen);
  };

  const handleTeleconference = () => {
    setTeleconferenceModalOpen(true);
  };

  const toggleUpdateModal = () => setUpdateModalOpen(!updateModalOpen);

  const toggleBloodModal = () => {
    setBloodSugarModalOpen(!bloodSugarModalOpen);
  };
  const toggleStudyCompletionModal = () =>
    setStudyCompletionModalOpen(!studyCompletionModalOpen);

  const handleUpdatePatient = () => {
    toggleUpdateModal();
  };

  const toggleDetailsModal = () => setDetailsModalOpen(!detailsModalOpen);

  const patientUpdated = async () => {
    try {
      // Get the updated subjects directly from getDashboard
      const updatedSubjects = await getDashboard();
      // Find the selected subject from the returned subjects
      const selected = updatedSubjects.find(subject => subject.selected);
      console.log("Selected Subject:", selected);
      if (selected) {
        setSelectedSubject(selected);
      }
    } catch (error) {
      console.error("Error updating patient data:", error);
    }
  };

  const handleRoomTemperatureAdded = () => {
    getDashboard();
  };

  const formatHeight = (height, heightUnit) => {
    if (heightUnit === "ft_in") {
      const feet = Math.floor(height / 12);
      const inches = height % 12;
      return `${feet}' ${inches}"`;
    } else {
      return `${height} ${heightUnit}`;
    }
  };

  const validate = () => {
    const newErrors = [];
    if (!lastAte) {
      newErrors.push({ field: "lastAte", message: "Please indicate when you last ate." });
    }
    if (!glucoseLevel || isNaN(glucoseLevel) || glucoseLevel < 0) {
      newErrors.push({ field: "glucoseLevel", message: "Please enter a valid, non-negative glucose level." });
    }
    setErrors(newErrors);
    return newErrors.length === 0;
  };
  const getFieldError = (field) => {
    const error = errors.find((error) => error.field === field);
    return error ? error.message : null;
  };

  const handleSubmit = async () => {
    //console.log("Blood Sugar Level modal submit subjectId:", selectedSubjectId);

    if (validate()) {
      const data = {
        selectedSubjectId: selectedSubject.subjectId,
        recordingId: null,
        lastAte,
        bloodSugarLevel: Number(glucoseLevel),
      };
      setBloodModalLoading(true);
      console.log("Blood Sugar Data:", data);

      const subjectIdx = data.selectedSubjectId ?? null;
      const recordingIdx = data.recordingId ?? null;

      const lastAtex = {
        "last 1 hour": "Last_1_hour",
        "1-2 hours": "1-2",
        "2-3 hours": "2-3",
        "3-4 hours": "3-4",
        "4-5 hours": "4-5",
        "5+ hours": "5+",
      }[data.lastAte] || null;

      const bloodSugarLevelx = parseFloat(data.bloodSugarLevel);

      try {
        const res = await axios.post(`${BASE_URL}web/bloodSugar`, {
          subjectId: subjectIdx,
          recordingId: recordingIdx,
          didBloodSugarLevelMeasure: "yes",
          lastMealTime: lastAtex,
          bloodSugarLevel: bloodSugarLevelx,
        });
        console.log("Blood Sugar Response:", res);
        setRequestResult({ type: "success", message: "Blood sugar level recorded successfully." });
        setBloodModalLoading(false);
      } catch (err) {
        console.log("Error making request", err);
        setRequestResult({ type: "error", message: "Failed to record blood sugar level." });
        setBloodModalLoading(false);
      }
    }
  };
  //WebSocket Connection Functions

  const closeWebSocketConnection = (socket) => {
    if (socket?.current) {
      try {
        // Only close if socket exists and is in OPEN or CONNECTING state
        if (socket.current.readyState === WebSocket.OPEN ||
          socket.current.readyState === WebSocket.CONNECTING) {
          socket.current.close(1000, "Closing connection normally");
        }

        // Clear the socket reference
        socket.current = null;
        // Clear any existing reconnection attempts
        if (reconnectTimeoutRef?.current) {
          clearTimeout(reconnectTimeoutRef.current);
          reconnectTimeoutRef.current = null;
        }
        return true;
      } catch (error) {
        console.error("Error while closing WebSocket connection:", error);
        return false;
      }
    }
    return true;
  };

  const connectWebSocket = () => {

    const authToken = localStorage.getItem("accessToken_" + ENV_RESOURCE)?.replace(/"/g, "")
    const connectionUrl = `${SOCKET_URL}?Auth=${authToken}&Type=Manager&DeviceId=Web&Mode=All`


    const socket = new WebSocket(connectionUrl)
    socketRef.current = socket

    socket.addEventListener("open", event => {
      console.log("WebSocket connection established")
      clearTimeout(reconnectTimeoutRef.current)
    })

    socket.addEventListener("message", event => {
      const message = JSON.parse(event.data)
      console.log("WebSocket message received:", message)
      if (
        message.type === "STATUS_CHECK" &&
        message.data &&
        message.data.deviceInfo
      ) {
        const deviceId =
          message.data.deviceInfo.deviceId || message.connectionId
        if (deviceId) {
          setStatusData(prevStatusData => ({
            ...prevStatusData,
            [deviceId]: message.data.deviceInfo,
          }))
          setDashboardData(prevDashboardData =>
            prevDashboardData.map(device =>
              device.connectionId === deviceId
                ? {
                  ...device,
                  data: {
                    ...device.data,
                    deviceInfo: message.data.deviceInfo,
                  },
                }
                : device
            )
          )
          setLastMessages(prevMessages => {
            const deviceId = message.connectionId;
            const deviceMessages = prevMessages[deviceId] || [];
            const updatedMessages = [...deviceMessages, message];
            return { ...prevMessages, [deviceId]: updatedMessages };
          });
        }
        setDeviceStatuses(prev => ({
          ...prev,
          [message.connectionId]: message.data
        }));
      }

      // Update messages state
      if (message.sender === "Collector" && message.type === "MEASUREMENT") {
        setMessages(prevMessages => ({
          ...prevMessages,
          [message.connectionId]: message.data,
        }))
        setLastMessages(prevMessages => {
          const deviceId = message.connectionId;
          const deviceMessages = prevMessages[deviceId] || [];
          const updatedMessages = [...deviceMessages, message];
          return { ...prevMessages, [deviceId]: updatedMessages };
        });
      }
      if (
        message.sender === "Backend" &&
        message.type === "CONNECT" &&
        currentPageRef.current === 1 &&
        modalOpenRef.current
      ) {
        setMessages({})
        setLastMessages({})
        setAnnotationMessages({})
        setDashboardLoading(true)
        getDashboard()
      }
      if (message.sender === "Backend" && message.type === "MORE_MANAGER") {
        openClosingTab(false)
      }
      if (message.sender === "Backend" && message.type === "CLOSE_YOURSELF") {
        openClosingTab(true)
      }
      if (message.sender === "Backend" && message.type === "CONNECTION_ID") {
        setConnectionIdWithMessage(message.connectionId)
      }

      if (
        message.sender === "Backend" &&
        !modalOpenRef.current &&
        !addModalOpenRef.current &&
        !updateModalOpenRef.current &&
        !studyCompletionModalOpenRef.current &&
        !bloodSugarModalOpenRef.current
      ) {
        checkDashboardStatus()
      }

      if (
        message.sender === "Backend" &&
        modalOpenRef.current &&
        message.type === "DISCONNECT"
      ) {
        setDashboardData(prevDashboardData =>
          prevDashboardData.filter(
            device => device.connectionId !== message.data
          )
        )
        setMessages(prevMessages => ({
          ...prevMessages,
          [message.data]: "DISCONNECTED",
        }))
        setLastMessages(prevMessages => {
          const deviceId = message.data;
          const deviceMessages = prevMessages[deviceId] || [];
          const updatedMessages = [...deviceMessages, message]; // Keep last 10 messages
          return { ...prevMessages, [deviceId]: updatedMessages };
        });
      }

      if (message.type === "ANNOTATING_ADDED") {
        setAnnotationMessages(prev => ({
          prev,
          [message.data.annotatorId]: {
            type: "ANNOTATING_ADDED",
            data: message.data
          }
        }));
      }

      if (message.type === "ANNOTATING_BP") {
        setAnnotationMessages(prev => ({
          prev,
          [message.data.annotatorId]: {
            type: "ANNOTATING_BP",
            data: message.data
          }
        }));
      }

      if (message.type === "ANNOTATING_DONE") {
        setAnnotationMessages(prev => ({
          prev,
          result: {
            type: "ANNOTATING_DONE",
            data: message.data
          }
        }));
      }
      if (message.type === "SESSION_LEFT") {
        setAnnotationMessages(prev => ({
          prev,
          result: {
            type: "SESSION_LEFT",
            data: message.data
          }
        }));
      }
    })

    socket.addEventListener("error", event => {
      console.log("WebSocket error:", event)
      setLoading(false)
      refreshAccessToken()
      attemptReconnect()
    })

    socket.addEventListener("close", event => {
      console.log("WebSocket connection closed:", event)
      attemptReconnect()
    })
  }

  const attemptReconnect = () => {
    const attempReconnectMode = localStorage.getItem("selectedMode") || "All";
    if (attempReconnectMode !== 'All' && attempReconnectMode !== 'VideoRecording') {
      return; // Don't reconnect if not in valid mode
    }
    clearTimeout(reconnectTimeoutRef.current)
    reconnectTimeoutRef.current = setTimeout(() => {
      console.log("Attempting to reconnect...")
      connectWebSocket()
    }, 2000)

  }

  // Functions
  // Utility function to check battery saving mode
  const isAnyDeviceInBatterySavingMode = () => {
    return Object.entries(deviceStatuses).some(([connectionId, status]) => {
      // First check if this device is still connected by checking if it exists in dashboardData
      const deviceExists = dashboardData.some(device => device.connectionId === connectionId);
      // Only check battery saver mode if device is still connected
      return deviceExists && status?.deviceInfo?.isBatterySaverModeActive;
    });
  };

  const getWarningMessage = () => {
    if (dashboardData.length + connectedCameraDevices.length === 0) {
      return {
        message: "Please connect a device to start a recording",
        icon: <Smartphone className="me-2" size={18} />,
        hint: "Connect your mobile device or camera to begin recordings."
      };
    }


    if (noSubjects) {
      return {
        message: "Please create and select a subject to start a recording",
        icon: <Activity className="me-2" size={18} />,
        hint: "Create a new patient profile or select an existing one."
      };
    }
    if (isAnyDeviceInBatterySavingMode()) {
      return {
        message: "One or more devices is in battery saving mode",
        icon: <AlertTriangle className="me-2" size={18} />,
        hint: "Please disable battery saving mode on all connected devices to proceed with the recording."
      };
    }

    if (!deviceCheck) {
      return {
        message: "One or more devices does not have enough space",
        icon: <AlertTriangle className="me-2" size={18} />,
        hint: "Free up space on your connected devices to ensure successful recording."
      };
    }

    if (ENV_RESOURCE === 'dca-master' && !hasBluetoothEnabled) {
      return {
        message: "At least one device must have Bluetooth enabled",
        icon: <Bluetooth className="me-2" size={18} />,
        hint: "Enable Bluetooth on at least one connected device to proceed."
      };
    }

    return null;
  };

  const warning = getWarningMessage();
  const isButtonDisabled = Boolean(warning) || modalLoading;

  const detectCameras = () => {
    detectAxisCameras();
    detectHanwhaCameras();
  }

  const detectAxisCameras = () => {
    axisCameras.forEach(camera => {
      AxisUtility.checkIfCameraConnected(camera, setAxisCameras);
    });
  }

  const detectHanwhaCameras = () => {
    hanwhaCameras.forEach(camera => {
      HanwhaUtility.checkIfCameraConnected(camera, setHanwhaCameras);
    });
  }

  const openClosingTab = closeMessage => {
    setCloseYourself(closeMessage)
    setOverwriteManagerModalOpen(true)
  }

  async function refreshAccessToken() {
    const refreshToken = JSON.parse(localStorage.getItem("refreshToken_" + ENV_RESOURCE))
    try {
      const res = await axios.post(`${AUTH_BASE_URL}user/refresh-token`, {
        refreshToken,
      })
      if (res.status === 200) {
        localStorage.setItem(
          "accessToken_" + ENV_RESOURCE,
          JSON.stringify(res.data.accessToken)
        )
        setDashboardLoading(true)
        getDashboard()
      } else {
        console.log("Failed to refresh access token")
        window.location.href = "/login"
      }
    } catch (RefreshErr) {
      console.log("Error refreshing access token", RefreshErr)
      window.location.href = "/login"
    }
  }

  const handleDeleteDevices = async () => {
    try {
      await axios.get(`${BASE_URL}web/deleteDevices`)
      // After successful deletion, refresh the dashboard
      setDashboardLoading(true)
      getDashboard()
      toggleDeleteDevicesModal()
    } catch (error) {
      console.error("Error deleting devices:", error)
      alert("An error occurred while deleting devices. Please try again.")
    }
  }

  const checkDashboardStatus = () => {
    console.log("Checking dashboard status")
    getDashboard()
  }

  const setConnectionIdWithMessage = id => {
    setConnectionId(id)
    connectionIdRef.current = id
  }

  const hasBluetoothEnabled = () => {
    return dashboardData.some(device => device.bleDevice === "On");
  };

  async function getDashboard() {
    setLoading(true);
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const res = await axios.post(`${BASE_URL}web/dashboard`, {
        timezone: timezone,
      });

      // Process devices with default values
      const updatedDevices = res.data.devices.map(device => {
        const isIphone = device.deviceName.toLowerCase().includes('iphone');
        return {
          ...device,
          camera: device.camera || 'Back',
          bleDevice: device.bluetooth !== null ? (device.bluetooth ? 'On' : 'Off')
            : (isIphone ? 'On' : 'Off'),
          mode: device.mode || 'Face',
          ppgDeviceOn: device.ppgDeviceOn || 'Right',
          data: {
            ...device.data,
            deviceInfo: {
              ...device.data?.deviceInfo
            }
          }
        };
      });

      // Merge user changes
      const mergedDevices = updatedDevices.map(device => ({
        ...device,
        ...userChanges[device.connectionId],
      }));

      const subjects = res.data.subjects.map(subject => ({
        subjectId: subject.subjectId,
        subjectName: subject.subjectName,
        selected: subject.selected,
        birthYear: subject.birthYear,
        gender: subject.gender,
        height: subject.height,
        heightUnit: subject.heightUnit,
        weight: subject.weight,
        weightUnit: subject.weightUnit,
        email: subject.email,
        studyCompleted: subject.studyCompleted,
        todayRecordings: subject.todayRecordings,
        allTimeRecordings: subject.allTimeRecordings,
        concomitantMedication: subject.concomitantMedication,
      }));

      // Update room temperature
      if (res.data.roomTemperature && res.data.roomTemperatureUnit) {
        setRoomTemperature(res.data.roomTemperature);
        setRoomTemperatureUnit(res.data.roomTemperatureUnit);
      } else {
        setRoomTemperature(null);
        setRoomTemperatureUnit(null);
      }

      // Update statusData based on dashboard data
      const newStatusData = {};
      mergedDevices.forEach(device => {
        newStatusData[device.connectionId] = device.data?.deviceInfo;
      });

      // Set all states
      await Promise.all([
        new Promise(resolve => {
          setStatusData(newStatusData);
          resolve();
        }),
        new Promise(resolve => {
          setDashboardData(mergedDevices);
          resolve();
        }),
        new Promise(resolve => {
          setSubjects(subjects);
          resolve();
        })
      ]);

      setDashboardLoading(false);
      setLoading(false);

      // Return the subjects for use in patientUpdated
      return subjects;
    } catch (err) {
      console.log("Error fetching dashboard:", err);
      setDashboardLoading(false);
      setLoading(false);
      throw err;
    }
  }

  const handleSettingChange = async (deviceId, settings) => {
    console.log("Multiple settings change", deviceId, settings);

    // Update local state for all settings
    const updatedData = dashboardData.map(device => {
      if (device.connectionId === deviceId) {
        const updatedDevice = { ...device };
        // Apply all setting changes to the device
        Object.entries(settings).forEach(([setting, value]) => {
          updatedDevice[setting] = value;
        });
        return updatedDevice;
      }
      return device;
    });

    // Save all user changes at once
    setUserChanges(prevChanges => ({
      ...prevChanges,
      [deviceId]: {
        ...prevChanges[deviceId],
        ...settings
      },
    }));

    console.log("Updated data", updatedData)

    setDashboardData(updatedData)
    // Find the device to get current settings
    const device = updatedData.find(d => d.connectionId === deviceId);
    if (!device) return;

    // Prepare the request payload
    const payload = {
      uniqueId: deviceId,
      mode: device.mode,
      camera: device.camera,
      bleEnabled: device.bleDevice === "On",
      ppgDeviceOn: device.ppgDeviceOn
    }

    try {
      const response = await axios.post(`${BASE_URL}web/deviceSettingChange`, payload);
      console.log("Device setting change notification sent successfully:", response.data);
    } catch (error) {
      console.error("Failed to notify backend about device setting change:", error);

    }
  }

  const handleConfirm = async (recordingId) => {
    setModalLoading(true)
    const mobileDeviceInfo = dashboardData.map(device => ({
      connectionId: device.connectionId,
      camera: device.camera,
      bleEnabled: device.bleDevice === "On",
      mode: device.mode,
      ppgDeviceOn: device.ppgDeviceOn
    }))

    const connectedCameraInfo = connectedCameraDevices.map(device => ({
      cameraType: device.details.cameraHostname
    }))

    const requestBody = {
      recordingId: recordingId,
      subjectId: selectedSubject.subjectId,
      mobileDeviceInfo,
      connectedCameraInfo,
    }

    try {
      const response = await axios.post(
        `${BASE_URL}web/prepareForMeasurement`,
        requestBody
      )
      setMeasurementData({
        subjectId: response.data.subjectId,
        recordingId: response.data.recordingId,
      })
      setModalLoading(false)
      setDashboardData(response.data.devices) // Update devices with response data
      return response.data
    } catch (error) {
      console.error("Error preparing for measurement:", error)
      setModalLoading(false)
    }
  }

  const handlePatientSelect = async (patient, action = 'dashboard') => {
    if (patient.studyCompleted) {
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}web/selectSubject`, {
        subjectId: patient.subjectId
      });
      if (response.status === 200) {
        setSelectedSubject(patient);
        setCurrentView(action); // Set the view based on action
        console.log("PATIENT SELECTED:", action);
        
        getDashboard();
      }
    } catch (error) {
      console.error("Error selecting patient:", error);
      setError("Failed to select patient. Please try again.");
    }
    setLoading(false);
  };

  const { component: warningComponent, checks } = WarningAlert({
    devices: dashboardData,
    cameras: connectedCameraDevices,
    selectedSubject,
    noSubjects
  });


  return (
    <React.Fragment>
      <div className="page-content bg-light min-vh-100">
        <Container fluid>
          {error && (
            <Alert color="danger" className="d-flex align-items-center mb-4">
              <AlertCircle size={20} className="me-2" />
              {error}
            </Alert>
          )}

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{
              minHeight: 'calc(40vh)',  // Adjust based on your header/footer
              width: '90%'
            }}>
              <LoadingSpinner />
            </div>
          ) : !selectedSubject ? (
            <div>
              <Row>
                <Col lg={8} className="mx-auto">
                  {noSubjects ? (
                    <EmptyPatientState onAddPatient={toggleAddModal} />
                  ) : (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0">Select Patient</h5>
                        <Button color="primary" onClick={toggleAddModal}>
                          <UserPlus className="me-2" size={18} />
                          New Patient
                        </Button>
                      </div>
                      <PatientsList
                        subjects={subjects}
                        onPatientSelect={handlePatientSelect}
                        selectedSubject={selectedSubject}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          ) : (
            <div>
              {/* Dashboard Header*/}
              <div className="position-relative mb-4">
                <Row>
                  <Col xs={12} md={{ size: 4, offset: 0 }}>
                    <Button
                      color="link"
                      className="position-absolute text-muted p-0"
                      style={{
                        left: '-40px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        textDecoration: 'none'
                      }}
                      onClick={() => {
                        setSelectedSubject(null);
                        setCurrentView('dashboard');
                      }}
                      id="backButton"
                    >
                      <ArrowLeft size={32} />
                    </Button>
                    <UncontrolledTooltip placement="left" target="backButton">
                      Back to Patient List
                    </UncontrolledTooltip>
                  </Col>
                  <Col xs={12} md={{ size: 2, offset: 10 }}>
                    <Card
                      className="border-0 bg-gradient shadow-sm"
                      style={{ backgroundColor: '#E8F5E9', height: '56px' }}
                      onClick={toggleRoomTempModal}
                    >
                      <CardBody
                        className="py-2 d-flex justify-content-between align-items-center"
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-center">
                          <ThermometerSun size={18} className="text-success me-2" />
                          <span className="text-muted small">Room Temp</span>
                        </div>
                        <h5 className="mb-0 text-success">
                          {roomTemperature
                            ? `${roomTemperature}°${roomTemperatureUnit}`
                            : '--°F'}
                        </h5>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Card className="border-0 shadow-sm mt-2">
                  <CardBody>
                    <Row>
                      <Col>
                        <div className="d-flex align-items-start">
                          <div
                            className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                            style={{
                              width: '48px',
                              height: '48px',
                              backgroundColor: '#eef2ff'
                            }}
                          >
                            <span className="h4 mb-0 text-primary">
                              {selectedSubject?.subjectName.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div className="flex-grow-1">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-1">{selectedSubject?.subjectName}</h4>

                            </div>
                            <div className="d-flex align-items-center text-muted mb-1">
                              <Mail size={14} className="me-2" />
                              <span>{selectedSubject?.email}</span>

                            </div>
                            <div className="d-flex align-items-center text-muted mb-1">


                              {selectedSubject?.gender} • {new Date().getFullYear() - selectedSubject?.birthYear} years •
                              {formatHeight(selectedSubject.height, selectedSubject.heightUnit)} • {selectedSubject?.weight} {selectedSubject?.weightUnit}

                              <UncontrolledDropdown >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-ghost-secondary btn-icon btn-sm"
                                >
                                  <Settings size={18} />
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <DropdownItem onClick={handleUpdatePatient}>
                                    Update Patient
                                  </DropdownItem>
                                  {!selectedSubject?.studyCompleted && (
                                    <DropdownItem onClick={handleCompleteStudy}>
                                      Complete Study
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs="auto">
                        <div className="d-flex gap-2">
                          <Button color="info" onClick={handleImportantMedicationModal}>
                            <Pill size={16} className="me-1" />
                            Medication
                          </Button>
                          <Button color="info" onClick={handleBloodPressure}>
                            <Heart size={16} className="me-1" />
                            BP Record
                          </Button>
                          <Button color="info" onClick={handleBloodSugar}>
                            <Activity size={16} className="me-1" />
                            Blood Sugar
                          </Button>
                          <div className="border-start ms-2 ps-2">
                            <Button color="light" onClick={() => setSelectedSubject(null)}>
                              Change Patient
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </div>
              {/* Main Action*/}
              {
                (() => {
                  switch (currentView) {
                    case 'dashboard':
                      return (
                        <>
                          <div className="mb-4">
                            <div className="d-flex gap-3">
                              <Button
                                color="primary"
                                className="flex-grow-1 py-2"
                                onClick={toggleModal}
                                disabled={isButtonDisabled}
                              >
                                <Activity className="me-2" size={18} />
                                {modalLoading ? 'Preparing...' : 'New Recording'}
                              </Button>
                              <Button
                                color="primary"
                                className="flex-grow-1 py-2"
                                onClick={handleTeleconference}
                              >
                                <Video className="me-2" size={18} />
                                Teleconference
                              </Button>
                            </div>
                            {warningComponent}
                          </div>

                          {/* Connected Devices */}
                          <div>
                            <Card className="border-0 shadow-sm">
                              <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                  <div className="d-flex align-items-center">
                                    <h5 className="card-title mb-0">Connected Devices</h5>
                                    <Badge color="primary" pill className="ms-2">
                                      {dashboardData.length + connectedCameraDevices.length}
                                    </Badge>
                                  </div>
                                  <div className="d-flex gap-2">
                                    <Button color="light" size="sm" onClick={detectCameras} id="detectCameraBtn">
                                      <Camera size={16} />
                                    </Button>
                                    <UncontrolledTooltip placement="top" target="detectCameraBtn">
                                      Detect Cameras
                                    </UncontrolledTooltip>

                                    <Button
                                      color="light"
                                      size="sm"
                                      id="refreshDevicesBtn"
                                      onClick={() => {
                                        setDashboardLoading(true)
                                        getDashboard()
                                      }}
                                    >
                                      <RefreshCw size={16} />
                                    </Button>
                                    <UncontrolledTooltip placement="top" target="refreshDevicesBtn">
                                      Refresh Devices
                                    </UncontrolledTooltip>

                                    <Button
                                      color="danger"
                                      size="sm"
                                      id="deleteDevicesBtn"
                                      onClick={toggleDeleteDevicesModal}
                                    >
                                      <Trash2 size={16} />
                                    </Button>
                                    <UncontrolledTooltip placement="top" target="deleteDevicesBtn">
                                      Delete All Devices
                                    </UncontrolledTooltip>
                                  </div>
                                </div>

                                <Row className="g-3">
                                  {dashboardData.map(device => (
                                    <Col lg={6} key={device.connectionId}>
                                      <DeviceStatusDashboard
                                        deviceName={device.deviceName}
                                        onSettingsChange={(setting, value) =>
                                          handleSettingChange(device.connectionId, setting, value)
                                        }
                                        enableCameraSelection={true}
                                        enableBleSelection={true}
                                        statusData={statusData[device.connectionId]}
                                        measurementData={null}
                                        deviceState={null}
                                        camera={device.camera}
                                        bleDevice={device.bleDevice === "On"}
                                        deviceMode={device.mode}
                                        ppgDeviceOn={device.ppgDeviceOn}
                                        showFaceTracking={false}
                                      />
                                    </Col>
                                  ))}
                                </Row>

                                <Row>
                                  <>
                                    {connectedCameraDevices.map((camera, index) => {
                                      if (camera.type === "axis") {
                                        return (
                                          <Col key={camera.details?.deviceIP} md="6">
                                            <AxisCameraDeviceCard
                                              key={index}
                                              camera={camera}
                                              shouldResetZoom={true}
                                            />
                                          </Col>
                                        );
                                      } else if (camera.type === "hanwha") {
                                        return (
                                          <Col key={camera.details?.deviceIP} md="6">
                                            <HanwhaCameraDeviceCard
                                              key={index}
                                              camera={camera}
                                              shouldResetZoom={true}
                                            />
                                          </Col>
                                        );
                                      }
                                    })}
                                  </>
                                </Row>
                              </CardBody>
                            </Card>
                          </div>

                          {/* Patient Statistics */}
                          <div>
                            <DashboardStatistics
                              selectedSubject={selectedSubject}
                              baseUrl={BASE_URL}
                            />
                          </div>
                        </>
                      );

                    case 'ppg':
                      return (
                        <PPGDataCollection
                          selectedSubject={selectedSubject}
                          baseUrl={BASE_URL}
                          onBack={() => setCurrentView('dashboard')}
                        />
                      );

                    case 'breathing':
                      return (
                        <BreathingPPGDataCollection
                          selectedSubject={selectedSubject}
                          baseUrl={BASE_URL}
                          onBack={() => setCurrentView('dashboard')}
                        />
                      );

                    default:
                      console.log("Reached unknown view condition");
                      return null;
                  }
                })()
              }

            </div>
          )}
        </Container>
      </div>
{/*
BreathingExercise
BreathingBar
MinimalBreathing
BreathingArc
GeometricBloom
*/}

      <Modal isOpen={deleteDevicesModalOpen} toggle={toggleDeleteDevicesModal}>
        <ModalHeader toggle={toggleDeleteDevicesModal}>
          Delete All Devices
        </ModalHeader>
        <ModalBody>
          <p>
            This action will delete all mobile device connections. After
            deletion, you will need to go to your phones and click 'Reconnect
            WebSocket'.
          </p>
          <p>
            Please only proceed if the system is showing more devices than are
            actually connected.
          </p>
          <p>Are you sure you want to continue?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleDeleteDevicesModal}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleDeleteDevices}>
            Delete All Devices
          </Button>
        </ModalFooter>
      </Modal>

      <OverwriteManagerModal
        isOpen={overwriteManagerModalOpen}
        toggle={() => setOverwriteManagerModalOpen(false)}
        onConfirm={handleOverwriteConfirm}
        close={closeYourself}
      />
      <NewMeasurementModal
        isOpen={modalOpen}
        toggle={toggleModal}
        devices={dashboardData}
        cameras={connectedCameraDevices} // Pass connectedCameraDevices to the modal
        selectedSubject={selectedSubject}
        onConfirm={handleConfirm}
        modalLoading={modalLoading}
        setModalLoading={setModalLoading}
        messages={messages} // Pass messages to the modal
        measurementData={measurementData} // Pass measurement data to the modal
        currentPage={currentPage} // Pass currentPage to the modal
        setCurrentPage={setCurrentPage} // Pass setCurrentPage to the modal
        onSettingChange={handleSettingChange} // Pass handleSettingChange to the modal
        setDashboardData={setDashboardData} // Pass setDashboardData to the modal
        setBloodSugarModalOpen={setBloodSugarModalOpen}
        lastMessages={lastMessages}
        annotationMessages={annotationMessages}
        setAnnotationMessages={setAnnotationMessages}
        noSubjects={noSubjects}
      />

      <ImportantMedicationModal
        isOpen={medicationModalOpen}
        toggle={() => setMedicationModalOpen(false)}
        subjectId={selectedSubject?.subjectId}
        selectedSubject={selectedSubject}
      />
      <AddPatientModal
        isOpen={addModalOpen}
        toggle={toggleAddModal}
        onPatientAdded={getDashboard}
      />
      <RoomTemperatureModal
        isOpen={roomTempModalOpen}
        toggle={toggleRoomTempModal}
        onTemperatureAdded={handleRoomTemperatureAdded}
      />
      <TeleconferenceModal
        isOpen={teleconferenceModalOpen}
        toggle={() => setTeleconferenceModalOpen(false)}
        subjectId={selectedSubject?.subjectId}
        subjectEmail={selectedSubject?.email}
      />

      <UpdatePatientModal
        isOpen={updateModalOpen}
        toggle={toggleUpdateModal}
        subjectId={selectedSubject?.subjectId}
        onPatientUpdated={patientUpdated}
      />
      <ManualBloodPressureModal
        isOpen={bloodPressureModalOpen}
        toggle={() => setBloodPressureModalOpen(false)}
        subjectId={selectedSubject?.subjectId}
        onBloodPressureAdded={getDashboard}
      />
      <StudyCompletionModal
        isOpen={studyCompletionModalOpen}
        toggle={toggleStudyCompletionModal}
        subjectId={selectedSubject?.subjectId}
        onStudyCompleted={() => setSelectedSubject(null)}
      />
      <Modal isOpen={bloodSugarModalOpen} backdrop="static" keyboard={false}>
        {bloodModalLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <ClipLoader color={"#727cf5"} />
          </div>
        ) : (
          <div>
            <ModalHeader toggle={toggleBloodModal}>
              Blood Sugar Level
            </ModalHeader>

            {requestResult && (
              <ModalBody>
                <Alert color={requestResult.type === "success" ? "success" : "danger"}>
                  {requestResult.message}
                </Alert>
              </ModalBody>
            )}
            {!requestResult && <div>
              <ModalBody>
                <FormGroup>
                  <Label>When was the last time you ate?</Label>
                  <Input
                    type="select"
                    value={lastAte}
                    onChange={(e) => setLastAte(e.target.value)}
                    className={getFieldError("lastAte") ? "is-invalid" : ""}
                  >
                    <option value="">Select...</option>
                    <option value="last 1 hour">Last 1 hour</option>
                    <option value="1-2 hours">1-2 hours</option>
                    <option value="2-3 hours">2-3 hours</option>
                    <option value="3-4 hours">3-4 hours</option>
                    <option value="4-5 hours">4-5 hours</option>
                    <option value="5+ hours">5+ hours</option>
                  </Input>
                  {getFieldError("lastAte") && <Alert color="danger">{getFieldError("lastAte")}</Alert>}
                </FormGroup>
                <FormGroup>
                  <Label>Glucose level</Label>
                  <Input
                    type="number"
                    value={glucoseLevel}
                    onChange={(e) => setGlucoseLevel(e.target.value)}
                    className={getFieldError("glucoseLevel") ? "is-invalid" : ""}
                  />
                  {getFieldError("glucoseLevel") && <Alert color="danger">{getFieldError("glucoseLevel")}</Alert>}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleSubmit}>
                  Confirm
                </Button>
              </ModalFooter>
            </div>}
          </div>
        )}
      </Modal>


    </React.Fragment >
  )
}

Dashboard.propTypes = {
  wallet: PropTypes.any,
  onGetWallet: PropTypes.func,
}

export default withRouter(Dashboard)


export const EmptyPatientState = ({ onAddPatient }) => (
  <div className="text-center py-5">
    <div className="mb-4">
      <div className="d-inline-flex justify-content-center align-items-center bg-light rounded-circle" style={{
        width: '80px',
        height: '80px'
      }}>
        <UserPlus size={40} className="text-primary" />
      </div>
    </div>
    <h4 className="mb-3">No Patients Found</h4>
    <p className="text-muted mb-4" style={{ maxWidth: '400px', margin: '0 auto' }}>
      Get started by adding your first patient. Click the button below to create a new patient profile.
    </p>
    <Button color="primary" size="lg" onClick={onAddPatient} className="px-4">
      <UserPlus size={20} className="me-2" />
      Add Your First Patient
    </Button>
  </div>
);